"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useUserID;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useUserID() {
  return [(0, _useWebChatAPIContext.default)().userID];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VVc2VySUQudHMiXSwibmFtZXMiOlsidXNlVXNlcklEIiwidXNlcklEIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxTQUFULEdBQStCO0FBQzVDLFNBQU8sQ0FBQyxxQ0FBdUJDLE1BQXhCLENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VVc2VySUQoKTogW3N0cmluZ10ge1xuICByZXR1cm4gW3VzZVdlYkNoYXRBUElDb250ZXh0KCkudXNlcklEXTtcbn1cbiJdfQ==